
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Box } from "@mui/material";
import type { FC } from "react";
import type { ProductCardGroupProps } from "../lib/type";
import { ProductCard } from "./ProductCard";

export const ProductCardGroup: FC<ProductCardGroupProps> = ({ products, className, ...rest }) => {
    return (
        <Box
            className={cn(
                "grid grid-cols-3 gap-6 max-xl:grid-cols-2 max-md:grid-cols-1",
                className,
            )}
            {...rest}
        >
            {products.map((product, idx) => (
                <ProductCard key={product.id ?? idx} {...product} className={"h-auto"} />
            ))}
        </Box>
    );
};
